module.exports = __webpack_public_path__ + "static/img/card.d794eefd.jpg";